module.exports = __webpack_public_path__ + "img/logo.0df9ead5.png";